import React, { useContext } from "react";
import {
  Card,
  Row,
  Col,
  Space,
  Typography,
  Popconfirm,
  Tooltip,
  message,
} from "antd";
import Button from "../../../shared/globalStyling/Button";
import moment from "moment";
import { LibraryCreativesContext } from "../../../../core/components/creatives/library/LibraryCreativesProvider";
import { useCreativeNavigation } from "../hooks/useCreativeNavigation";

const AdGroupDetailsCard = ({
  adgroupinfo,
  onDeleted,
  mediaType = "DISPLAY",
}) => {
  const { navigateBack } = useCreativeNavigation();
  const { deleteAdGroupCreatives } = useContext(LibraryCreativesContext);

  const handleDelete = async () => {
    try {
      await deleteAdGroupCreatives({
        variables: {
          id: adgroupinfo.adGroupCreatives.id,
        },
      });
      message.success("Ad group deleted successfully.");
      if (onDeleted) onDeleted();
      navigateBack({
        mediaType: mediaType,
        isAdGroup: true
      });
    } catch (err) {
      message.error("Failed to delete ad group.");
    }
  };

  return (
    <Card
      title="AD GROUP DETAILS"
      extra={
        <Popconfirm
          placement="topLeft"
          title="Are you sure you want to delete this ad group? This action cannot be undone."
          onConfirm={handleDelete}
          okText="Delete"
          cancelText="Cancel"
        >
          <Tooltip title="Delete this ad group">
            <Button type="default" danger>
              Delete Ad Group
            </Button>
          </Tooltip>
        </Popconfirm>
      }
      className="ccard-detail"
    >
      <Space direction="vertical" style={{ width: "100%" }} size={0}>
        <Row>
          <Col span={6}>
            <Typography.Text light>Ad Units</Typography.Text>
          </Col>
          {/* <Col span={18}>
            <Typography.Text light>Assigned Live Campaigns</Typography.Text>
          </Col> */}
        </Row>
        <Space direction="vertical" size={20} style={{ width: "100%" }}>
          <Row>
            <Col span={6}>
              <Typography.Text strong>
                {adgroupinfo &&
                  adgroupinfo.adGroupCreatives &&
                  adgroupinfo.adGroupCreatives.medias &&
                  adgroupinfo.adGroupCreatives.medias.length}
              </Typography.Text>
            </Col>
            {/* <Col span={18}>
              <Typography.Text strong>TO DO</Typography.Text>
            </Col> */}
          </Row>

          <Row>
            <Col span={6}>
              <Typography.Text light>Last Updated</Typography.Text>
            </Col>
            <Col span={18}>
              <Typography.Text light>Created On</Typography.Text>
            </Col>
          </Row>
        </Space>
        <Space direction="vertical" size={20} style={{ width: "100%" }}>
          <Row>
            <Col span={6}>
              <Typography.Text strong>
                {adgroupinfo &&
                adgroupinfo.adGroupCreatives &&
                adgroupinfo.adGroupCreatives.updatedAt
                  ? moment(adgroupinfo.adGroupCreatives.updatedAt).format(
                      "MM/DD/YYYY - HH:mm"
                    )
                  : ""}
              </Typography.Text>
            </Col>
            <Col span={18}>
              <Typography.Text strong>
                {adgroupinfo &&
                adgroupinfo.adGroupCreatives &&
                adgroupinfo.adGroupCreatives.updatedAt
                  ? moment(adgroupinfo.adGroupCreatives.createdAt).format(
                      "MM/DD/YYYY - HH:mm"
                    )
                  : ""}
              </Typography.Text>
            </Col>
          </Row>
          {/* <Row>
            <Col span={6}>
              <Typography.Text light>Channel Partner</Typography.Text>
            </Col>
            <Col span={18}>
              <Typography.Text light>Advertiser</Typography.Text>
            </Col>
          </Row> */}
        </Space>
        {/* <Row>
          <Col span={6}>
            <Typography.Text strong>TO DO</Typography.Text>
          </Col>
          <Col span={18}>
            <Typography.Text strong>TO DO</Typography.Text>
          </Col>
        </Row> */}
      </Space>
    </Card>
  );
};

export default AdGroupDetailsCard;
